/**
 * CLEOGENE FAQ NAVIGATION
 * Gestion de la navigation par ancres et du responsive
 */

class CleogeneFaqNavigation {
  constructor() {
    this.nav = document.getElementById('faq-nav');
    this.navLinks = document.querySelectorAll('.cleogene-faq-nav-link');
    this.sections = document.querySelectorAll('.cleogene-faq-section');
    
    this.init();
  }

  init() {
    if (!this.nav) return;
    
    this.bindEvents();
    this.initScrollSpy();
  }

  bindEvents() {
    // Clic sur les liens de navigation
    this.navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        this.scrollToSection(targetId);
      });
    });
  }


  scrollToSection(sectionId) {
    const targetSection = document.getElementById(sectionId);
    if (!targetSection) return;

    const headerHeight = this.getHeaderHeight();
    const targetPosition = targetSection.offsetTop - headerHeight - 20;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }

  getHeaderHeight() {
    const header = document.querySelector('header');
    return header ? header.offsetHeight : 0;
  }

  initScrollSpy() {
    if (!this.sections.length) return;

    const observerOptions = {
      root: null,
      rootMargin: '-120px 0px -60% 0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.setActiveNavLink(entry.target.id);
        }
      });
    }, observerOptions);

    this.sections.forEach(section => {
      observer.observe(section);
    });
  }

  setActiveNavLink(activeSectionId) {
    this.navLinks.forEach(link => {
      const linkAnchor = link.getAttribute('data-anchor');
      if (linkAnchor === activeSectionId) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }

  // Méthode pour mettre à jour la navigation (si sections ajoutées dynamiquement)
  updateNavigation() {
    this.navLinks = document.querySelectorAll('.cleogene-faq-nav-link');
    this.sections = document.querySelectorAll('.cleogene-faq-section');
    this.bindEvents();
    this.initScrollSpy();
  }
}

// Animation de révélation au scroll
class ScrollReveal {
  constructor() {
    this.elements = document.querySelectorAll('.scroll-trigger');
    this.init();
  }

  init() {
    if (!this.elements.length) return;

    const observerOptions = {
      root: null,
      rootMargin: '-10% 0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate--slide-in');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    this.elements.forEach(element => {
      observer.observe(element);
    });
  }
}

// Gestion des accordéons personnalisée
class CleogeneAccordion {
  constructor() {
    this.accordions = document.querySelectorAll('.cleogene-faq-accordion-item details');
    this.init();
  }

  init() {
    this.accordions.forEach(accordion => {
      accordion.addEventListener('toggle', (e) => {
        if (e.target.open) {
          // Fermer les autres accordéons de la même section
          this.closeOtherAccordions(e.target);
        }
      });
    });
  }

  closeOtherAccordions(currentAccordion) {
    const currentSection = currentAccordion.closest('.cleogene-faq-section');
    if (!currentSection) return;

    const otherAccordions = currentSection.querySelectorAll('details');
    otherAccordions.forEach(accordion => {
      if (accordion !== currentAccordion && accordion.open) {
        accordion.open = false;
      }
    });
  }
}

// Utilitaires
const CleogeneUtils = {
  // Détection du support du scroll smooth
  supportsSmoothScroll: () => {
    return 'scrollBehavior' in document.documentElement.style;
  },

  // Polyfill pour le scroll smooth si nécessaire
  smoothScrollPolyfill: () => {
    if (!CleogeneUtils.supportsSmoothScroll()) {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const target = document.querySelector(this.getAttribute('href'));
          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        });
      });
    }
  },

  // Debounce pour les événements de scroll
  debounce: (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
};

// Initialisation quand le DOM est prêt
document.addEventListener('DOMContentLoaded', () => {
  // Initialiser les composants
  new CleogeneFaqNavigation();
  new ScrollReveal();
  new CleogeneAccordion();
  
  // Appliquer le polyfill si nécessaire
  CleogeneUtils.smoothScrollPolyfill();
  
  // Gestion des erreurs
  window.addEventListener('error', (e) => {
    console.warn('Erreur dans CleogeneFaqNavigation:', e.error);
  });
});

// Export pour utilisation externe si nécessaire
window.CleogeneFaqNavigation = CleogeneFaqNavigation;
window.CleogeneUtils = CleogeneUtils;
